import { decorate, action, observable } from 'mobx'
import autoBind from "auto-bind"



class OnBoardingStore {
  dialogOpened = false;

  currentActionIndex=-1;

  /**
 * @type { { message: string; state: 'idle' | 'loading' | 'completed' | 'error';, id:string; }[] }
 */
  actions = [];

  constructor() {
    autoBind(this)
  }

  openDialog() {
    this.dialogOpened = true;
  }

  closeDialog() {
    this.dialogOpened = false;
  }

  addAction(action) {
    this.actions.push(action)
  }

  updateAction(action, i) {
    this.actions[i] = action;
  }

  setActions(actions) {
    this.actions = actions;
  }

  setCurrentActionIndex(index){
    this.currentActionIndex=index
  }
}

decorate(OnBoardingStore, {
  dialogOpened: observable,
  actions: observable,
  currentActionIndex: observable,
  //
  openDialog: action,
  closeDialog: action,
  //
  addAction: action,
  updateAction: action,
  setActions: action,
  setCurrentActionIndex:action
})

export default OnBoardingStore;